"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _dictDetail = _interopRequireDefault(require("./dictDetail"));

var _dict = _interopRequireDefault(require("@/api/system/dict"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  name: null,
  description: null,
  dictDetails: []
};
var _default = {
  name: 'Dict',
  components: {
    crudOperation: _CRUD.default,
    pagination: _Pagination.default,
    rrOperation: _RR.default,
    udOperation: _UD.default,
    dictDetail: _dictDetail.default
  },
  cruds: function cruds() {
    return [(0, _crud.default)({
      title: '字典',
      url: 'api/dict',
      crudMethod: _objectSpread({}, _dict.default)
    })];
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm)],
  data: function data() {
    return {
      queryTypeOptions: [{
        key: 'name',
        display_name: '字典名称'
      }, {
        key: 'description',
        display_name: '描述'
      }],
      rules: {
        name: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }]
      },
      permission: {
        add: ['admin', 'dict:add'],
        edit: ['admin', 'dict:edit'],
        del: ['admin', 'dict:del']
      }
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    if (this.$refs.dictDetail) {
      this.$refs.dictDetail.query.dictName = '';
    }

    return true;
  }), (0, _defineProperty2.default)(_methods, "handleCurrentChange", function handleCurrentChange(val) {
    if (val) {
      this.$refs.dictDetail.query.dictName = val.name;
      this.$refs.dictDetail.dictId = val.id;
      this.$refs.dictDetail.crud.toQuery();
    }
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeToEdit, function (crud, form) {
    // 将角色的菜单清空，避免日志入库数据过长
    form.dictDetails = null;
  }), _methods)
};
exports.default = _default;